<template>
    <div @click.stop="goToDetailPage(item.id?item.id:item.slug)" :class="'type-'+item.type">
        <div class="product-image" :style="'background-image: url('+item.image_url+')'"></div>
        <div v-if="location=='gifting-campaigns'" class="stock-message" :class="stockMessageClass()">{{ stockMessage() }}</div>
        <div v-if="item.allocated!==null && location=='gifting-campaigns'" class="allocated-message" :class="allocatedMessageClass()">{{ item.allocated + ' units' }}</div>
        <div class="product-info">
            <h6>{{ item.name }}</h6>
            <div v-if="location=='marketplace' && item.type=='physical'" class="item-brand">{{ item.brand_name }}&nbsp;</div>

            <div class="item-price" v-if="item.type=='physical'" >
                <span v-if="location=='marketplace'" >{{ item.price_ex_vat | toCurrency }}</span>
                <span v-else-if="item.product_type=='kitted' && location=='gifting-campaigns'" >Kitted Gift Set</span>
                <span v-else >Individually Stocked Item</span>

                <div v-if="location=='marketplace'" class="item-price-inc-vat">{{ item.price | toCurrency }} inc. VAT</div>
            </div>
            
            <div class="item-price" v-else-if="item.type=='voucher' && item.face_value_limits" >
                <span>from <b>{{ item.face_value_limits.lower | toCurrency }}</b> to <b>{{ item.face_value_limits.upper | toCurrency }}</b></span>
            </div>
            <div class="item-price" v-else-if="item.type=='voucher' && item.denominations" >
                <span>from <b>{{ item.denominations[0] | toCurrency }}</b> to <b>{{ item.denominations[item.denominations.length-1] | toCurrency }}</b></span>
            </div>
            <div class="item-price" v-else-if="item.type=='voucher'" >
                <span>from <b>{{ 2 | toCurrency }}</b> to <b>{{ 500 | toCurrency }}</b></span>
            </div>
        </div>
        <div class="product-actions">
            <span v-if="item.allocated!==null && location=='gifting-campaigns'" class="ws-button small ws-button-main" @click="goToDetailPage(item.id)">MORE DETAILS</span>
            <span v-if="item.allocated!==null && location=='gifting-campaigns' && item.product_type==='kitted'" class="ws-button small" :class="team.plan!=='pro'?' pro-disabled':''" @click.stop="openRestockModal(item.id)">RESTOCK</span>

            <!-- <span v-if="location=='marketplace'" @click.stop="goToDetailPage(item.id)" class="ws-button small ws-button-main">MORE DETAILS</span> -->
            <span v-if="location=='marketplace' && team.corporation_id != 5" @click.self.stop="openSendModal(item.id?item.id:item.slug)" class="ws-button small" 
			:class="(index === 0 && showTutorial(2)) ? 'in-tutorial': ''">DIRECT SEND
				<tutorial-tooltip v-if="index === 0 && showTutorial(2)" :location="location" tooltip="send-direct"></tutorial-tooltip>
			</span>
            <span v-if="location=='marketplace'" @click.self.stop="openLinkModal(item.id?item.id:item.slug)" class="ws-button small" 
			:class="[(index === 0 && showTutorial(3)) ? 'in-tutorial' : '', (team.plan!=='pro') ? 'pro-disabled' : '']">GENERATE LINK
                <tutorial-tooltip v-if="index === 0 && showTutorial(3)" :location="location" tooltip="generate-link"></tutorial-tooltip>
            </span>
        </div>

        <div v-if="item.terms && item.terms.diet" class="product-icons">
            <div v-for="diet in item.terms.diet" class="product-icon" :style="'background-image: url('+diet.icon+')'" v-if="diet.slug!='alcohol-free'" v-tooltip="diet.name"></div>
        </div>
    </div>
</template>

<script>
import TutorialTooltip from "@/components/modals/TutorialTooltip";

export default {
    name: "ProductListItem",
    components: { TutorialTooltip },
    props: [ 'item', 'location', 'index'],
    methods: {
        goToDetailPage(id) {
            if (this.tutorial && this.tutorial.enabled) return;
			
			if (this.location=='marketplace') {
                this.$emit('open-detail-modal', id);
                return;
            }

            if (this.item.allocated!==null) {
              this.$store.commit('fetchProduct', {});
              this.$router.push({name:'products-detail', params: {id}});
            } else {
              alert('This gift box component is general Bookblock HUB product, not specific to your team or company, so you can not manage its properties.');
            }

        },
        openRestockModal(id) {
            if (!this.proCheck('Requesting product restocks')) return;
            this.$emit('open-restock-modal', id);
        },
        openSendModal(id) {
            this.$emit('open-send-modal', id);
        },
        openLinkModal(id) {
            if (!this.proCheck('Generating gift claim links')) return;
            this.$emit('open-link-modal', id);
        },
        stockMessage() {
            return this.stockMessageClass().replaceAll('-',' ');
        },
        stockMessageClass() {
            if (this.item.stock >= 20) return 'in-stock';
            else if (this.item.stock >= 1) return 'low-stock';
            else return 'out-of-stock';
        },
        allocatedMessageClass() {
            if (this.item.allocated >= 20) return 'alloc';
            else if (this.item.allocated >= 1) return 'low-alloc';
            else return 'not-alloc';
        },
		showTutorial(i) {
            return this.tutorial.enabled && (i === this.tutorial.currentStep);
        },
    },
    computed: {
        team() {
			return this.$store.state.team.detail;
		},
        modals() {
            return this.$store.state.modals;
        },
        tutorial() {
            return this.$store.state.tutorials[this.location];
        }
    },
}
</script>
